import { getContractABI, getContractAddress } from "../utils/abiHelper";
import { ether, getWeb3IfAvailable, parseError, toNumber, toRealNumber } from "../web3Utils";
import { ContractService } from "./ContractService";

export class StakingService extends ContractService{

    constructor(args = {}) {
        super();
        this.contractType = 'Staking'
        this.abi = getContractABI(this.contractType);
        this.addHooks();
    }

    async preHook() {
        this.web3 = await getWeb3IfAvailable()
        this.accounts = await this.web3.eth.getAccounts();
        this.contractAddress = await getContractAddress(this.contractType);
        this.contractInstance = new this.web3.eth.Contract(
            this.abi,
            this.contractAddress
        );
    }
    
    async getStakeInfo() {
        try{
            const stakeInfo = await this.contractInstance.methods.getStakeInfo(this.accounts[0]).call();
            console.log(
                'stakeInfo', 
                toRealNumber(stakeInfo.startTime),
                toRealNumber(stakeInfo.amount),
                toRealNumber(stakeInfo.periodInDays),
            )
            return {
                startTime: toRealNumber(stakeInfo.startTime),
                amount: toNumber(stakeInfo.amount),
                periodInDays: toRealNumber(stakeInfo.periodInDays),
            }
        } catch(err) {
            throw parseError(err);
        }
    }


    async estimate() {

        try{
            const stakeEstimate = await this.contractInstance.methods.estimate(this.accounts[0]).call();
            console.log('stakeEstimate', 
                toRealNumber(stakeEstimate.rewardCount),
                toRealNumber(stakeEstimate.nextRewardTime),
                toRealNumber(stakeEstimate.periodToBeRewarded),
                toRealNumber(stakeEstimate.periodAccumulated),
                stakeEstimate.rewardWallet
            )
            return {
                nextRewardTime: toRealNumber(stakeEstimate.nextRewardTime),
                rewardCount: toRealNumber(stakeEstimate.rewardCount),
                ruleName: stakeEstimate.ruleName,
            }
        } catch(err) {
            throw parseError(err);
        }
    }

    async stake({
        periodInDays,
        amount
    }) {
        try {
            const gasPrice = await this.web3.eth.getGasPrice();

            let args = [
                ether(amount),
                Number(periodInDays)
            ], options = {
                gasPrice,
                from: this.accounts[0]
            };

            const estimatedGas = await this.contractInstance
                .methods
                .stake( ...args)
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .stake( ...args )
                .send(options);
        } catch(err) {
            throw parseError(err);
        }
        return 'Tokens staked successfully!';
    }

    async unStake( params = {} ) {
        try {
            const gasPrice = await this.web3.eth.getGasPrice();

            let options = {
                gasPrice,
                from: this.accounts[0]
            };

            const estimatedGas = await this.contractInstance
                .methods
                .unStake()
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .unStake()
                .send(options);
        } catch(err) {
            throw parseError(err);
        }
        return 'Tokens unstaked successfully!';
    }

    async claim( params = {} ) {
        try {
            const gasPrice = await this.web3.eth.getGasPrice();

            const estimatedGas = await this.contractInstance.methods
                .claim()
                .estimateGas({
                    from: this.accounts[0]
                });
             
            await this.contractInstance
                .methods
                .claim()
                .send({ 
                    from: this.accounts[0],
                    gasPrice,
                    gas: estimatedGas + 5000,
                });
        } catch(err) {
            throw parseError(err);
        }
        return 'Rewards claimed successfully!';
    }

}